'use strict';

module.exports = function () {
    var laneRowSymbols = function (type, element, color1, color2) {
        switch (type) {
            case 'Conn':
                element.append('svg:polygon')
                    .attr('points', '24.585,6.299 24.585,9.064 11.195,9.064 11.195,14.221 24.585,14.221 24.585,16.986 31.658,11.643 ')
                    .attr('fill', color1);
                element.append('svg:polygon')
                    .attr('points', '10.99,17.822 3.916,23.166 10.99,28.51 10.99,25.744 24.287,25.744 24.287,20.59 10.99,20.59 ')
                    .attr('fill', color1);
                return;
            case 'IOC Severity':
                element.append('svg:polygon')
                    .attr('transform', 'translate(0, 3)')
                    .attr('points', '18.155,3.067 5.133,26.932 31.178,26.932 ')
                    .attr('fill', color1);
                element.append('svg:polygon')
                    .attr('transform', 'translate(0, 3)')
                    .attr('points', '19.037,21.038 19.626,12.029 15.888,12.029 16.477,21.038 ')
                    .attr('fill', color2);
                element.append('rect')
                    .attr('transform', 'translate(0, 3)')
                    .attr('x', 16.376)
                    .attr('y', 22.045)
                    .attr('fill', color2)
                    .attr('width', 2.838)
                    .attr('height', 2.448);
                return;
            case 'DNS':
                element.append('svg:path')
                    .attr('d', 'M20.909,13.115c0-0.07,0-0.106-0.071-0.106c-0.283,0-6.022,0.813-7.935,0.956'+
                        'c-0.036,0.955-0.071,2.053-0.071,3.009l2.267,0.106v8.707c0,0.071-0.035,0.143-0.142,0.178l-1.877,0.07'+
                        'c-0.035,0.92-0.035,1.982-0.035,2.938c1.452,0,3.33-0.036,4.818-0.036h4.888V26l-1.949-0.07'+
                        'C20.801,22.39,20.874,16.938,20.909,13.115z')
                    .attr('fill', color1);
                element.append('svg:path')
                    .attr('d', 'M17.473,10.921c1.771,0,3.329-1.274,3.329-3.187c0-1.486-1.098-2.867-3.152-2.867'+
                        'c-1.948,0-3.259,1.451-3.259,2.938C14.391,9.611,15.949,10.921,17.473,10.921z')
                    .attr('fill', color1);
                return;
            case 'HTTP':
                element.append('circle')
                    .style('fill', color1)
                    .attr('cx', 18)
                    .attr('cy', 18)
                    .attr('r', 14);
                element.append('svg:path')
                    .attr('d', 'M24.715,19.976l-2.057-1.122l-1.384-0.479l-1.051,0.857l-1.613-0.857l0.076-0.867l-1.062-0.325l0.31-1.146'+
                        'l-1.692,0.593l-0.724-1.616l0.896-1.049l1.108,0.082l0.918-0.511l0.806,1.629l0.447,0.087l-0.326-1.965l0.855-0.556l0.496-1.458'+
                        'l1.395-1.011l1.412-0.155l-0.729-0.7L22.06,9.039l1.984-0.283l0.727-0.568L22.871,6.41l-0.912,0.226L21.63,6.109l-1.406-0.352'+
                        'l-0.406,0.596l0.436,0.957l-0.485,1.201L18.636,7.33l-2.203-0.934l1.97-1.563L17.16,3.705l-2.325,0.627L8.91,3.678L6.39,6.285'+
                        'l2.064,1.242l1.479,1.567l0.307,2.399l1.009,1.316l1.694,2.576l0.223,0.177l-0.69-1.864l1.58,2.279l0.869,1.03'+
                        'c0,0,1.737,0.646,1.767,0.569c0.027-0.07,1.964,1.598,1.964,1.598l1.084,0.52L19.456,21.1l-0.307,1.775l1.17,1.996l0.997,1.242'+
                        'l-0.151,2.002L20.294,32.5l0.025,2.111l1.312-0.626c0,0,2.245-3.793,2.368-3.554c0.122,0.238,2.129-2.76,2.129-2.76l1.666-1.26'+
                        'l0.959-3.195l-2.882-1.775L24.715,19.976z')
                    .attr('fill', '#3f3f3f')
                    .attr('transform', 'translate(4,4) scale(0.75)');
                return;
            case 'SSL':
                element.append('svg:path')
                    .attr('fill', color1)
                    .attr('d', 'M25.5,16.1v-2.7h0c0,0,0,0,0,0c0-4.1-3.3-7.4-7.4-7.4c-4.1,0-7.4,3.3-7.4,7.4c0,0,0,0,0,0v2.7H9.3'+
                    'v11.8h17.8V16.1H25.5z M22.9,13.7v2.4h-9.4v-2.4c0,0,0,0,0,0c0-2.6,1.5-5,4.7-5C21.3,8.8,22.9,11.1,22.9,13.7'+
                    'C22.9,13.7,22.9,13.7,22.9,13.7z');
                return;
            case 'Endpoint':
                element.append('svg:path')
                    .attr('d', 'M28.649,8.6H7.351c-0.684,0-1.238,0.554-1.238,1.238v14.363c0,0.684,0.554,1.238,1.238,1.238h7.529'+
                        'l-1.09,3.468v0.495h8.419v-0.495l-1.09-3.468h7.529c0.684,0,1.237-0.555,1.237-1.238V9.838C29.887,9.153,29.333,8.6,28.649,8.6z'+
                        'M28.477,22.072H7.635V10.074h20.842V22.072z')
                    .attr('fill', color1);
                return;
            case 'Stealth':
                element.append('path')
                    .attr('fill', color1)
                    .attr('d', 'M23.587,26.751c-0.403,0.593-1.921,4.108-5.432,4.108c-3.421,0-5.099-3.525-5.27-3.828'+
                        'c-2.738-4.846-4.571-9.9-4.032-17.301c6.646,0,9.282-4.444,9.291-4.439c0.008-0.005,3.179,4.629,9.313,4.439'+
                        'C28.014,15.545,26.676,21.468,23.587,26.751z');
                element.append('svg:path')
                    .attr('fill', color2)
                    .attr('d', 'M13.699,23.661c1.801,3.481,2.743,4.875,4.457,4.875l0.011-19.85c0,0-2.988,2.794-7.09,3.251'+
                        'C11.076,16.238,11.938,20.26,13.699,23.661z');
                return;
            case 'Stealth_drop':
                element.append('svg:path')
                    .attr('fill', color1)
                    .attr('d', 'M23.587,26.751c-0.403,0.593-1.921,4.108-5.432,4.108c-3.421,0-5.099-3.525-5.27-3.828'+
                        'c-2.738-4.846-4.571-9.9-4.032-17.301c6.646,0,9.282-4.444,9.291-4.439c0.008-0.005,3.179,4.629,9.313,4.439'+
                        'C28.014,15.545,26.676,21.468,23.587,26.751z');
                element.append('svg:path')
                    .attr('fill', color2)
                    .attr('d', 'M13.699,23.661c1.801,3.481,2.743,4.875,4.457,4.875l0.011-19.85c0,0-2.988,2.794-7.09,3.251'+
                        'C11.076,16.238,11.938,20.26,13.699,23.661z');
                return;
            case 'Email':
                element.append('polygon')
                    .style('fill', color1)
                    .attr('points', '18,17.3 8.7,11.6 27.3,11.6 ');
                element.append('polygon')
                    .style('fill', color1)
                    .attr('points', '28.4,24.4 7.6,24.4 7.6,13.1 18,19.7 28.4,13.1 ');
                return;
            case 'File':
                element.append('svg:path')
                    .attr('d', 'M13.702,12.807h13.189c-0.436-0.655-1.223-1.104-2.066-1.104c0,0-7.713,0-8.361,0'+
                        'c-0.386-0.796-1.278-1.361-2.216-1.361H7.562c-1.625,0-1.968,0.938-1.839,2.025l2.104,11.42c0.146,0.797,0.791,1.461,1.594,1.735'+
                        'c0,0,2.237-10.702,2.378-11.308C12.005,13.334,12.403,12.807,13.702,12.807z')
                    .attr('fill', color1);
                element.append('svg:path')
                    .attr('d', 'M29.697,13.898c0,0-14.47-0.037-14.68-0.037c-1.021,0-1.435,0.647-1.562,1.289l-2.414,10.508h16.716'+
                        'c1.146,0,2.19-0.821,2.383-1.871l1.399-7.859C31.778,14.706,31.227,13.848,29.697,13.898z')
                    .attr('fill', color1);
                return;
            case 'Applications':
                element.append('rect')
                    .attr('x', 10)
                    .attr('y', 10)
                    .attr('height', 4)
                    .attr('width', 17)
                    .style('fill', color1);
                element.append('rect')
                    .attr('x', 10)
                    .attr('y', 16)
                    .attr('height', 4)
                    .attr('width', 17)
                    .style('fill', color1);
                element.append('rect')
                    .attr('x', 10)
                    .attr('y', 22)
                    .attr('height', 4)
                    .attr('width', 17)
                    .style('fill', color1);
                return;
            case 'Active Defense':
                element.append('svg:path')
                    .attr('transform', 'translate(9,6)')
                    .attr('d', 'M9,0L0,4v6c0,5.4,3.6,10,8.5,11.5C13.4,20,17,15.4,17,10V4L9,0z M3.8,10h4L3.2,5.1h5.6l4,5.9h-3l4,6L3.8,10z')
                    .attr('fill', color1);
                return;
            default:
                return;
        }
    }
    return laneRowSymbols;
}


/** WEBPACK FOOTER **
 ** ./src/pages/services/lanerowsymbols.js
 **/